export default __webpack_public_path__ + "static/media/1.4cb2e87e.png";